module.exports = "https://cdn.realtymogul.com/static/media/img_panel_stairs.504b2631.jpg";